<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height:100%;
  font-size:16px;
}
/* 公共样式，宽度1200 居中 */
.fixed{ 
  width:1200px;
  margin:0 auto;
}
body{
  margin:0;
  height:100%
}
ul{
  list-style: none;
  margin:0
}
.blankBanner{
  height:300px;
  background:#fff;
}
#app .ql-editor img{
    max-width:100%
}
</style>
